import React from 'react'
import styled from '@emotion/styled'
import titleBackground from 'view/styles/images/brokerTecTitleBg.svg'
import * as constants from 'view/styles/constants'
import { TitleBarButtons } from './TitleBarButtons'
import { Locale, Translation } from 'locale'

interface TitleBarProps {
  title: string
  window: fin.OpenFinWindow
}

const TitleBarContainer = styled.div`
  position: relative;
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  background-color: black;
  -webkit-user-select: none;
  -webkit-app-region: drag;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  padding: 4px 15px 4px 20px;
`

const Title = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
`

const TitleBackground = styled.div`
  background: url(${titleBackground}) no-repeat left;
  position: absolute;
  top: 0;
  left: 8px;
  width: 40px;
  height: 40px;
  opacity: 0.5;
`

const TitleLogoText = styled.div`
  font-family: NEXWeb;
  font-weight: ${constants.FontWeight.Medium};
  color: white;
  font-size: 20px;
`
const TitleCaption = styled.div`
  margin-top: 3px;
  opacity: 0.75;
  font-weight: ${constants.FontWeight.SemiBold};
  font-size: 10px;
  color: white;
`

export class TitleBarLauncher extends React.Component<TitleBarProps> {
  render() {
    const { window, title } = this.props

    return (
      <TitleBarContainer>
        <Title>
          <TitleBackground />
          <TitleLogoText>{title}</TitleLogoText>
          <TitleCaption>{Locale.translate(Translation.SC_APP_DESCRIPTION)}</TitleCaption>
        </Title>
        <TitleBarButtons window={window} />
      </TitleBarContainer>
    )
  }
}
